import { ButtonA, GroupA, PaperA, TitleA } from "@src/ruix";
import { TitleAWithCardProps } from "@src/ruix/types";

const TitleAWithCard = (props: TitleAWithCardProps) => {
	const { title, buttonList, paper } = props;

	return (
		<PaperA {...paper} gap={15}>
			<TitleA {...title}></TitleA>
			<GroupA order="row-center-center" gap={10}>
				{buttonList?.map((button, index) => (
					<ButtonA key={`titleAWithCardButton-${index}`} {...button}></ButtonA>
				))}
			</GroupA>
		</PaperA>
	);
};

export default TitleAWithCard;
